module.exports = [
  {
    slug: "/sustainability",
    bgImage: require('../assets/07_Sustainability/DAIF_Extra2_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/07_Sustainability/07_DAIF_SUSTAINABILITY_01.mp4'),
    videoBgLoop: require('../assets/07_Sustainability/07_DAIF_SUSTAINABILITY_01_loop.mp4'),
    bgImage2: require('../assets/07_Sustainability/DAIF_Extra2_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/sustainability/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/sustainability/1",
    bgImage: require('../assets/07_Sustainability/DAIF_Extra2_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/07_Sustainability/07_DAIF_SUSTAINABILITY_02.mp4'),
    videoBgLoop: require('../assets/07_Sustainability/07_DAIF_SUSTAINABILITY_02_loop.mp4'),
    bgImage2: require('../assets/07_Sustainability/DAIF_Extra2_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/sustainability",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "89.7%",
      },
      {
        url: "/sustainability/2",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/sustainability/2",
    bgImage: require('../assets/07_Sustainability/DAIF_Extra2_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/07_Sustainability/07_DAIF_SUSTAINABILITY_03.mp4'),
    videoBgLoop: require('../assets/07_Sustainability/07_DAIF_SUSTAINABILITY_03_loop.mp4'),
    bgImage2: require('../assets/07_Sustainability/DAIF_Extra2_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/sustainability/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "89.7%",
      },
      {
        url: "/sustainability/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/sustainability/3",
    bgImage: require('../assets/07_Sustainability/DAIF_Extra2_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/07_Sustainability/07_DAIF_SUSTAINABILITY_04.mp4'),
    videoBgLoop: require('../assets/07_Sustainability/07_DAIF_SUSTAINABILITY_04_loop.mp4'),
    bgImage2: require('../assets/07_Sustainability/DAIF_Extra2_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/sustainability/2",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  
]